<template>
	<div style="width: 95%;margin: 0 auto;">
		<div
			style="width: 100%;height: 30px;border-left: 3px solid red;margin-top: 25px;font-size: 24px;font-weight: 800;padding-left: 25px;">
			交流中心
		</div>

		<div @click="isShow = !isShow"
			style="width: 200px;height: 30px;border: 1px solid #000;text-align: center;line-height: 30px;margin-top: 10px;">
			点击添加交流中心
		</div>

		<!-- <div style="width: 90%;margin-left: 3%;height: 40px;margin-top: 25px;box-shadow: #6e6e6e 0px 0px 10px;">
			<div @click="isShow = !isShow"
				style="width: 120px;height: 40px;font-weight: 800;text-align: center;line-height: 40px;font-size: 18px;margin-left: 20px;border: 1px solid #6e6e6e;box-sizing: border-box;">
				添加
			</div>
		</div> -->

		<div style="width: 100%;min-height: 300px;margin-top: 25px;">
			<div v-show="!isShow" style="height: 300px;text-align: center;line-height: 300px;">
				<div style="height: 100px;width: 100%;border-bottom: 1px dashed #6e6e6e;" v-for="(item,index) in dkyja">
					<div style="width: 50%;height: 100px;float: left;">
						<div style="width: 70%;height: 50px;line-height: 50px;text-align: left;font-size: 20px;font-weight: 800;color: #000;float: left;overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;">
							{{item.title}}
						</div>
						<!-- <div v-show="item.status=='0'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div>
						<div v-show="item.status=='1'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div>
						<div v-show="item.status=='2'"
							style="width: 20%;height: 30px;margin-top: 10px;border: 1px solid orangered;float: left;line-height: 30px;">
							待审核
						</div> -->
						<div style="width: 100%;height: 50px;line-height: 60px;float: left;text-align: left;">
							<span class="el-icon-time"></span>
							<span>发布时间：</span>{{getLocalTime(item.create_time)}} <span
								style="margin-left: 20px;"></span>收益金额:<i class="iconfont icon-qianbao"
								style="margin-left: 5px;margin-right: 5px;"></i><span>{{item.sy_money}}</span>
						</div>
					</div>
					<div style="width: 50%;height: 100px;float: left;position: relative;">
						<div @click="xiugaia(item)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 20px;border: 1px solid #6e6e6e;">
							修改
						</div>
						<router-link tag="div" :to="{path: '/dkyjdetail', query: {id:item.id,title:item.title}}"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;top: 10px;right: 130px;border: 1px solid #6e6e6e;color: blue;">
							查看
						</router-link>
						<div @click="detela(item.id)"
							style="width: 100px;height: 30px;line-height: 30px;position: absolute;bottom: 10px;right: 20px;border: 1px solid #6e6e6e;">
							删除
						</div>
					</div>
				</div>
				<!-- 分页 -->
				<div style="height: 40px;text-align: center;margin-top: 55px;">
					<el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage"
						:page-size="PageSize" layout="total, prev, pager, next" :total="Totals">
					</el-pagination>
				</div>
			</div>
			<div v-show="isShow">
				<div style="width: 100%;height: 50px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						标题:
					</div>
					<el-input v-model="form.title" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>

				<!-- <div style="width: 100%;height: 50px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						作者:
					</div>
					<el-input v-model="form.author" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div> -->

				<div style="width: 100%;height: 50px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						行业分类:
					</div>
					<el-select v-model="form.fid" filterable placeholder="请选择" style="float: left;margin-top: 10px;">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>


				<div style="width: 100%;height: 50px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						图片:
					</div>
					<el-upload class="upload-demo" style="width: 200px;height: 30px;float: left;margin-top: 10px;"
						action="https://admin.shipoe360.com/api/picture/upload_pic" :on-preview="handlePreview"
						:on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handsuccess" :limit="1"
						:on-exceed="handleExceed" :file-list="fileList">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</div>



				<div style="width: 100%;height: 550px;margin-top: 20px;">
					<div
						style="width: 40%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						内容 <span style="font-size: 12px;">上传图片大小控制再“600 x 350”之间)</span> :
					</div>
					<div style="float: left;width: 90%;margin-left: 5%;height: 500px;">
						<vue-tinymce v-model="form.content" :setting="setting" />
					</div>
				</div>


				<div style="height: 50px;width: 200px;margin: 0 auto;">
					<el-button type="primary" @click="onSubmit">立即创建</el-button>
					<el-button @click="isShow = !isShow">取消</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				isShow: false,
				fileListss: [],
				fileLists: [],
				fileList: [],
				fileLis: [],
				currentPage: 1, //当前页
				PageSize: 10, //当前每页数据
				Totals: 100, //总数据条数
				xgpda: false,
				setting: {
					menubar: false,
					toolbar: 'code undo redo restoredraft | cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link anchor | alignleft aligncenter alignright alignjustify outdent indent | \
					styleselect formatselect fontselect fontsizeselect | bullist numlist | blockquote subscript superscript removeformat | \
					table image media charmap emoticons hr pagebreak insertdatetime print preview | fullscreen | bdmap indent2em lineheight formatpainter axupimgs ltr rtl | emoticons help | wordcount',
					toolbar_drawer: "sliding",
					quickbars_selection_toolbar: "removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor",
					plugins: "link image media table lists fullscreen quickbars advlist autosave directionality emoticons help imagetools pagebreak preview print wordcount",
					language: 'zh_CN', //本地化设置
					height: 500,
					selector: '#textarea1',
					automatic_uploads: false,
					images_upload_url: 'https://admin.shipoe360.com/ueditorphp/controller.php',
					fontsize_formats: '12px 14px 16px 18px 24px 36px 48px 56px 72px',
					font_formats: '微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;',

				},
				options: [{
						value: '4',
						label: "船舶工程"
					},
					{
						value: "5",
						label: "海洋工程"
					},
					{
						value: "6",
						label: "海洋油气"
					},
					{
						value: '7',
						label: '海洋开发'
					}, {
						value: '8',
						label: '船舶设计'
					}, {
						value: '9',
						label: '豪华邮轮'
					}, {
						value: '10',
						label: '海洋平台'
					}, {
						value: '11',
						label: '海上风电'
					}, {
						value: '30',
						label: 'LNG船舶'
					}, {
						value: '13',
						label: '海工船'
					}, {
						value: '35',
						label: '职场能量'
					}, {
						value: '2',
						label: '船东要闻'
					}, {
						value: '3',
						label: '船厂要闻'
					}, {
						value: '1',
						label: '订单播报'
					}, {
						value: '15',
						label: '设备资讯'
					}, {
						value: '12',
						label: '项目通告'
					}, {
						value: '16',
						label: '装备资讯'
					}, {
						value: '17',
						label: '展会播报'
					}, {
						value: '18',
						label: '会议播报'
					}, {
						value: '19',
						label: '党建要闻'
					}, {
						value: '20',
						label: '港口航运'
					}, {
						value: '21',
						label: '能源环保'
					}, {
						value: '22',
						label: '智能制造'
					}, {
						value: '23',
						label: '军民融合'
					}, {
						value: '24',
						label: '船海金融'
					}, {
						value: '25',
						label: '船海法务'
					}, {
						value: '26',
						label: '船海数据'
					}, {
						value: '27',
						label: '船海规范'
					}, {
						value: '28',
						label: '一带一路'
					}, {
						value: '29',
						label: '专家访谈'
					}, {
						value: '33',
						label: '技术交流'
					}, {
						value: '31',
						label: '专家讲堂'
					}, {
						value: '32',
						label: '百科知识'
					}, {
						value: '34',
						label: '主流船型'
					}, {
						value: '36',
						label: '今日要闻'
					}, {
						value: '37',
						label: '企业咨询'
					},

				],
				form: {
					fid: '',
					title: '',
					author: '',
					mp3: '',
					vlink: '',
					endtime: '',
					picture: '',
					video: '',
					videoo: '',
					isTop: '',
					uid: '',
				},
				tpa: '',
				dkyja: '',
				qid: '',
			}
		},
		mounted() {
			this.getinfo()
		},
		methods: {
			handlePreview(file) {
				console.log(file);
			},
			getLocalTime(nS) {
				return new Date(parseInt(nS) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ');
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			handsuccess(response, file, fileList) {
				this.form.picture = response.data.path
				console.log(this.form.picture)
			},
			xiugaia(val) {
				var sb = true
				console.log(val)
				this.xgpda = true
				this.isShow = true
				// this.form.fid = val.fid
				this.form.title = val.title
				this.form.mp3 = val.mp3
				this.form.vlink = val.vlink
				this.form.endtime = val.endtime
				this.form.picture = val.picture
				this.form.content = val.content
				this.form.video = val.video
				this.form.videoo = val.videoo
				this.form.isTop = val.isTop
				this.form.mid = val.mid
				this.form.id = val.id
				this.form.model = 'daka'
				this.form.type = 'content'


				// if (this.form.picture === 'http://admin.shipoe360.com/public/') {
				// 	this.form.picture = ''
				// } else {
				// 	this.form.picture = this.form.picture.replace(new RegExp('http://admin.shipoe360.com/public/', 'g'),
				// 		'')
				// }
				if (this.form.picture == null ) {
					this.form.picture = ''
				} else {
					this.form.picture = this.form.picture.replace(new RegExp('http://admin.shipoe360.com/public/', 'g'),
						'')
				}
				console.log(this.form.picture)
				this.qid = val.id

				this.options.forEach((item) => {
					if (item.value == val.fid) {
						this.form.fid = item.value
					}
				})

				console.log(this.form.fid)

				let fileArr = [];
				let fileObj = {};
				fileObj.name = "图片";
				fileObj.url = val.picture;
				fileArr.push(fileObj);
				this.fileList = fileArr


				// let fileArrs = [];
				// let fileObjs = {};
				// fileObjs.name = "视频";
				// fileObjs.url = val.videoo;
				// fileArrs.push(fileObjs);
				// this.fileLists = fileArrs

				// let fileArrss = [];
				// let fileObjss = {};
				// fileObjss.name = "音频";
				// fileObjss.url = val.mp3;
				// fileArrss.push(fileObjss);
				// this.fileListss = fileArrss
			},
			async detela(id) {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/Common/delete', {
					model: 'daka',
					type: 'content',
					mid: '8',
					uid: loginInfo.id,
					field_name: 'id',
					field_id: id
				})
				if (res.data.code == 200) {
					this.$notify({
						title: '成功',
						message: '删除成功',
						type: 'success'
					});
				}
				this.getinfo()
			},
			async handleCurrentChange(val) {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.get('api/picture/person_page_dkyj', {
					uid: loginInfo.id,
					page: val
				})
				console.log(res)
				this.dkyja = res.data.data.list
				this.Totals = res.data.data.count
				this.PageSize = res.data.data.rows_limit
			},
			async getinfo() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.get('api/picture/person_dkyj_index', {
					uid: loginInfo.id
				})
				console.log(res)
				this.dkyja = res.data.data.list
				this.Totals = res.data.data.count
				this.PageSize = res.data.data.rows_limit
			},
			async onSubmit() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				console.log(this.form.picture)
				this.form.uid = loginInfo.id
				if (this.xgpda == true) {
					// console.log(this.form)
					// this.$axios({
					// 	url: 'https://admin.shipoe360.com/api/Common/edit',
					// 	method: 'post',
					// 	data: this.form
					// }).then(res => {
					// 	if (res.data.code == 200) {
					// 		this.$notify({
					// 			title: '成功',
					// 			message: '修改成功',
					// 			type: 'success'
					// 		});
					// 		this.getinfo();
					// 	}
					// })
					let res = await http.post('api/Common/edit', {
						model: 'daka',
						type: 'content',
						mid: '8',
						id:this.form.id,
						title: this.form.title,
						fid: this.form.fid,
						picture: this.form.picture,
						content: this.form.content,
						uid: loginInfo.id
					})
					console.log(res)
					if (res.data.code == 200) {
						this.$notify({
							title: '成功',
							message: '添加成功',
							type: 'success'
						});
						this.getinfo();
						this.form.title = ''
						this.form.fid = ''
						this.form.picture = ''
						this.form.content = ''
					}
				} else if (this.xgpda == false) {
					// this.form.picture = this.tpa
					// 	this.$axios({
					// 		url: 'https://admin.shipoe360.com/api/picture/dkyj_content_add',
					// 		method: 'post',
					// 		data: this.form
					// 	}).then(res => {
					// 		if (res.data.code == 200) {
					// 			this.$notify({
					// 				title: '成功',
					// 				message: '添加成功',
					// 				type: 'success'
					// 			});
					// 		}
					// 		this.getinfo();
					// 		this.form.title = ''
					// 		this.form.money = ''
					// 		this.form.mp3 = ''
					// 		this.form.vlink = ''
					// 		this.form.endtime = ''
					// 		this.form.picture = ''
					// 		this.form.content = ``
					// 		this.form.video = ''
					// 		this.form.videoo = ''
					// 		this.form.down = ''
					// 		this.fileLis = []
					// 		this.fileList = []
					// 		this.fileListss = []
					// 	})
					let res = await http.post('api/common/add', {
						model: 'daka',
						type: 'content',
						mid: '8',
						title: this.form.title,
						fid: this.form.fid,
						picture: this.form.picture,
						content: this.form.content,
						uid: loginInfo.id
					})
					console.log(res)
					if (res.data.code == 200) {
						this.$notify({
							title: '成功',
							message: '添加成功',
							type: 'success'
						});
						this.getinfo();
						this.form.title = ''
						this.form.fid = ''
						this.form.picture = ''
						this.form.content = ''
					}
				}
			}
		}
	}
</script>

<style>
</style>
